export default __webpack_public_path__ + "static/media/eye.e1cc0e45.png";